export default {
  feature: {
    accountText: 'tenancy',
    projectText: 'compartment',
  },
  billing: {
    dataTransfer: {
      enabled: false,
    },
    cdn: {
      enabled: false,
    },
    invoice: {
      enabled: false,
    },
    alarm: {
      enabled: false,
    },
    costPivot: {
      enabled: false,
    },
    costTrend: {
      enabled: false,
    },
  },
};
